/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import { saveKioskAC } from '../../action-creators';
import { setInitialValues } from './utils/form-utils';
import { Field, Formik } from 'formik';
import { ControlBoxField, InputField } from './fields';
import { DropdownField } from './fields/dropdown-field';
import { ActionsSection } from './buttons/actions-section';
import { Form } from 'semantic-ui-react';

const FIELDS = ['controlBoxId', 'kioskType', 'uuid', 'secret', 'logoUrl', 'layoutName', 'themeName'];

function KioskForm(props: any) {
  const { dispatch, onClose } = props;
  const boundHandleSubmit = (values: any, formikActions: any) =>
    dispatch(saveKioskAC({ data: values, formikActions, closeDialog: onClose }));
  return (
    <Formik initialValues={setInitialValues(FIELDS, props)} onSubmit={boundHandleSubmit}>
      {({ values, handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <Field name="uuid" label="UUID" component={InputField} disabled={!!values.id} />
          <Field name="secret" label="Secret" component={InputField} />
          <Field name="controlBoxId" component={ControlBoxField} />

          <Field name="logoUrl" label="logoUrl" component={InputField} />
          <Field label="Layout Name" name="layoutName">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Layout Name"
                options={[
                  { value: 'default', text: 'Default' },
                  { value: 'dualLang', text: 'dualLang' },
                  { value: 'modern', text: 'modern' }
                ]}
              />
            )}
          </Field>
          <Field label="Theme Name" name="themeName">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Theme Name"
                options={[
                  { value: 'default', text: 'Default' },
                  { value: 'blue', text: 'blue' },
                  { value: 'green', text: 'green' }
                ]}
              />
            )}
          </Field>

          <Field label="Kiosk type" name="kioskType">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Display type"
                options={[
                  { value: 'web', text: 'Web/Touch screen kiosk (web)' },
                  { value: 'hw', text: 'ESP Kiosk (hw)' }
                ]}
              />
            )}
          </Field>
          <ActionsSection isNew={!values.id} disabled={isSubmitting} onCancel={props.onClose} />
        </Form>
      )}
    </Formik>
  );
}

const ConnectedComponent = connect((state: any) => ({
  app: state.app,
  serviceProviders: state.serviceProviders,
  queues: state.queues,
  controlBoxes: state.controlBoxes
}))(KioskForm);

export default ConnectedComponent;
